import { memo, type JSX } from 'react';

import { AccessibilityPanel, Header } from '@/widgets/Layout';

interface Props {
  isPanelShown: boolean;
}

export const HeaderWrapper = memo(({ isPanelShown }: Props): JSX.Element => {
  return (
    <header className="header">
      <AccessibilityPanel isPanelShown={isPanelShown} />
      <Header />
    </header>
  );
});
